import { useEffect } from "react";
import { Toaster } from "../component/toaster";
import { MainLayout } from "../layout/main-layout";
import { useSetRecoilState } from "recoil";
import { selectedMenu } from "../state/atom/generic";
import { Menu } from "../shared/generic.constant";
import { MisList } from "../component/report/mis-list";
import { MisFilter } from "../component/report/mis-filter";
import { validatePermission } from "../utility/permission";
import { ReportMapOL } from "../component/report/report-map-ol";

export const Report = () => {
  validatePermission("menu", "report");
  const setSelectedMenu = useSetRecoilState(selectedMenu);

  useEffect(() => {
    setSelectedMenu(Menu.report);
  }, []);
  return (
    <MainLayout>
      <Toaster></Toaster>
      <MisFilter></MisFilter>
      <ReportMapOL classList="full-map gis-map"></ReportMapOL>
      <MisList></MisList>
    </MainLayout>
  );
};
